const PromoCode = ({ value, onChange, onApply, state,disabled }) => {
  return (
    <div className="promo-box">
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Have Promo Code?"
        disabled={disabled}
      />

      <button   onClick={() => onApply(value)} disabled={disabled || state.loading}  style={{marginTop:"-1px"}}>
        {state.loading ? "..." : "Apply"}
      </button>

      {state.message && (
        <div className={`promo-message ${state.success ? "success" : "error"}`}>
          {state.message}
        </div>
      )}
    </div>
  );
};

export default PromoCode;
